module.exports = __webpack_public_path__ + "static/img/file-read-1480.1687185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newUi-icon/file-read-1480.png
// module id = EtXj
// module chunks = 96